export default "__VITE_ASSET__DqakaOv7__"